function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import CrossIcon from "@releaseit/assets/icons/cross.svg";
import { cn, cnm } from "../utils";
export function Dialog(_param) {
    var overlayProps = _param.overlayProps, children = _param.children, props = _objectWithoutProperties(_param, [
        "overlayProps",
        "children"
    ]);
    return /*#__PURE__*/ _jsxs(DialogPrimitive.Root, _objectSpread({}, props, {
        children: [
            children,
            /*#__PURE__*/ _jsx(DialogPrimitive.Overlay, _objectSpread({}, overlayProps, {
                className: cn("animate-fade-in", "fixed inset-0 z-20 bg-black/50 backdrop-blur-sm", overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.className)
            }))
        ]
    }));
}
export function DialogContent(_param) {
    var _withClose = _param.withClose, withClose = _withClose === void 0 ? true : _withClose, children = _param.children, className = _param.className, props = _objectWithoutProperties(_param, [
        "withClose",
        "children",
        "className"
    ]);
    return /*#__PURE__*/ _jsxs(DialogPrimitive.Content, _objectSpread({}, props, {
        className: cnm("animate-dialog-enter", "fixed top-1/4 left-1/2 z-50 -translate-x-1/2", "w-[95vw] max-w-xl rounded-lg bg-white p-6 shadow-card md:p-8", className),
        children: [
            children,
            withClose && /*#__PURE__*/ _jsx(DialogClose, {
                className: cnm("absolute top-3.5 right-3.5", "inline-flex items-center justify-center rounded-full p-1", "transition focus:outline-none focus-visible:ring"),
                children: /*#__PURE__*/ _jsx(CrossIcon, {
                    className: "h-6 w-6 text-gray-600 hover:text-gray-700"
                })
            })
        ]
    }));
}
export function DialogTitle(_param) {
    var className = _param.className, props = _objectWithoutProperties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(DialogPrimitive.Title, _objectSpread({}, props, {
        className: cnm("text-xl font-medium text-gray-800", className)
    }));
}
export function DialogDescription(_param) {
    var className = _param.className, props = _objectWithoutProperties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(DialogPrimitive.Description, _objectSpread({}, props, {
        className: cnm("text-gray-600", className)
    }));
}
export function DialogActions(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        className: "mt-4 flex justify-end space-x-4",
        children: React.Children.map(children, function(child) {
            return /*#__PURE__*/ _jsx(DialogClose, {
                asChild: true,
                children: child
            });
        })
    });
}
export var DialogTrigger = DialogPrimitive.Trigger;
export var DialogClose = DialogPrimitive.Close;
Dialog.Trigger = DialogTrigger;
Dialog.Content = DialogContent;
Dialog.Title = DialogTitle;
Dialog.Description = DialogDescription;
Dialog.Actions = DialogActions;
Dialog.Close = DialogClose;
